// react
import { fromJS } from "immutable";
import PropTypes from "prop-types";
import React from "react";

// components
import SelectInput from "../../../components/Inputs/SelectInput";

// styles
import css from "./LogDetails.module.scss";

const Filters = (props) => {
	const { filters, updateFilters } = props;

	const results = fromJS([
		{ id: "all", label: "All" },
		{ id: "created", label: "Created" },
		{ id: "skipped", label: "Skipped" },
		{ id: "synced", label: "Synced" },
		{ id: "reactivated", label: "Reactivated" },
		{ id: "deactivated", label: "Deactivated" },
		{ id: "noUpdates", label: "No Updates" },
	]);

	const handleSelectChange = (value) => {
		updateFilters((draft) => {
			draft.userUpdatesStatus = value;
		});
	};

	return (
		<div className={css.logDetailsfilters}>
			<div className={css.filterLabel}>Status</div>
			<SelectInput onChange={handleSelectChange} value={filters.userUpdatesStatus} results={results} />
		</div>
	);
};

Filters.propTypes = {
	updateFilters: PropTypes.func.isRequired,
	filters: PropTypes.object.isRequired,
};

export default Filters;
